module.exports = __webpack_public_path__ + "img/ergocises.dd7e17f4.png";